<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="visibilities" formControlName="visibility" optionLabel="name"
            optionValue="value" placeholder="visibility"></p-dropdown>
            <label for="visibility">visibility</label>
            @for (validation of validationMessages.visibility; track validation) {
              <span>
                @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="teamtypes" formControlName="teamType" optionLabel="name"
            optionValue="value" placeholder="teamType"></p-dropdown>
            <label for="teamType">teamType</label>
            @for (validation of validationMessages.teamType; track validation) {
              <span>
                @if (form1.get('teamType').hasError(validation.type) && (form1.get('teamType').dirty || form1.get('teamType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          Select User to be added
          <app-user-search (onUserSelected)="onUserAdded($event)"  [showCreateUser]="false"></app-user-search>

        </div>


        @if (team?.teamUserAPIList?.length > 0) {
          <p-table [columns]="userColumns" [value]="team?.teamUserAPIList" [tableStyle]="{'min-width': '50rem'}" >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>Remove</th>
                @for (col of columns; track col) {
                  <th>
                    {{col.header}}
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>
                  <i class="pi pi-times" (click)="removeUserFromTeam(rowData?.user)"></i>
                </td>
                <td>
                  {{rowData?.user?.useId}}
                </td>
                <td>
                  {{rowData?.user?.lastName}}
                </td>
                <td>
                  {{rowData?.user?.firstName}}
                </td>
                <td>
                  {{rowData?.user?.useId}}
                </td>
                <td>
                </td>
              </tr>
            </ng-template>
          </p-table>
        }

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (teamId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!teamId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (teamId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
